/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_Source_AmountInputs */

const cs_deal_provision_source_amount = /** @type {(inputs: Deal_Provision_Source_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pevná částka`)
};

const en_deal_provision_source_amount = /** @type {(inputs: Deal_Provision_Source_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed amount`)
};

/**
* | output |
* | --- |
* | "Fixed amount" |
*
* @param {Deal_Provision_Source_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_source_amount = /** @type {((inputs?: Deal_Provision_Source_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_Source_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_source_amount(inputs)
	return cs_deal_provision_source_amount(inputs)
});